<script>
export default {
  components: {},
  props: {
    group: {
      type: Number,
      default: 0,
    },
    recipientInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      shareRecordConfirm: false,
    }
  },
  computed: {},

  methods: {
    closeDialog() {
      this.$emit('closeDialog', false)
      setTimeout(() => {
        this.selected = null
      }, 500)
    },
    goBack() {
      this.$emit('backClick', false)
    },
    navigateToScreen() {
      this.closeDialog()
      document.getElementById('ShareDocTabID').click()
      document.getElementById('updateGetAllData').click()
    },
  },
}
</script>

<template>
  <v-card color="#FFFFFF;" min-height="450px">
    <v-card-text>
      <!-- close button -->
      <div :class="$style.closeButtonDiv">
        <v-btn
          color="offblack"
          :class="$style.closeButton"
          icon
          @click="closeDialog"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <!-- card dialog -->
      <template>
        <v-row justify="center">
          <v-col cols="12" md="10" sm="10">
            <div align="center" class="mt-3">
              <img
                width="350"
                height="230"
                :class="$style.logo"
                :src="
                  require('@assets/images/safehaven/SharingDocuments02.svg')
                "
              />
            </div>

            <v-row class="mt-2">
              <p :class="$style.headText">Email invite sent</p>
            </v-row>
            <v-row class="mt-2">
              <p :class="$style.subheadText"
                >A temporary link with
                {{ recipientInfo.duration.duration_days }} day access to your
                documents has been sent to {{ recipientInfo.recipient_email }}.
                This link will expire in 24 hours.</p
              >
            </v-row>

            <!-- get started button -->
            <v-row no-gutters align="center" justify="center" class="mt-4">
              <v-btn
                :class="['primary-btn', $style.doneButton]"
                elevation="0"
                width="236"
                height="37"
                @click="navigateToScreen"
                >Done</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.logo {
  height: auto;
  padding-top: 0;
}
.closeButton {
  position: absolute;
  top: 20px;
  right: 0;
  padding-left: 0;
}
.closeButtonDiv {
  position: relative;
}

.headText {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #454648;
}

.subheadText {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}

.doneButton {
  align-items: center !important;
  justify-content: center !important;
  width: 376px !important;
  height: 50px !important;
}
@media screen and (max-width: 1263px) {
  .doneButton {
    top: 180px;
    width: 340px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 960px) {
  .doneButton {
    top: 180px;
    width: 340px !important;
    height: 50px !important;
  }
  .headText {
    margin-left: 20px !important;
  }
  .subheadText {
    margin-left: 20px !important;
  }
  .logo {
    margin-top: 100px !important;
  }
}
@media screen and (max-width: 599px) {
  .doneButton {
    top: 180px;
    width: 340px !important;
    height: 50px !important;
  }
}
</style>
